import MenuService from "../../services/MenuService";
const menuService = new MenuService();

let paginate = {
    rowsPerPage: 50,
    sortBy: 'created_at',
    descending: true,
};

const state = {
    menus: {
        data: [],
    },
    currentEditedMenu: null,
    currentScaleMenu: null,
};

const getters = {
    menus: state => state.menus,
    currentEditedMenu: state => state.currentEditedMenu,
    currentScaleMenu: state => state.currentScaleMenu,
};

const mutations = {
    setMenus: (state, menus) => (state.menus = menus),
    setCurrentEditedMenu: (state, currentEditedMenu) => (state.currentEditedMenu = currentEditedMenu !== null ? Object.assign({}, currentEditedMenu) : null),
    setCurrentScaleMenu: (state, currentScaleMenu) => (state.currentScaleMenu = currentScaleMenu !== null ? Object.assign({}, currentScaleMenu) : null),
};

const actions = {
    async fetchMenus({commit}, query) {
        const requestQuery = query !== null && query.hasOwnProperty('params') ? query.params : paginate;
        paginate = requestQuery;

        const {data} = await menuService.fetchMenus(query.patientId, requestQuery);
        commit('setMenus', data);
    },
    setCurrentEditedMenu({commit}, menu) {
        commit('setCurrentEditedMenu', menu);
    },
    setCurrentScaleMenu({commit}, menu) {
        commit('setCurrentScaleMenu', menu);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
